import { ChatCircleDots, CheckCircle, Confetti, HandHeart, Lightbulb, ArrowClockwise, Star, HandTap } from "@phosphor-icons/react";
import { SectionShell } from "../../styleguide/Primitives";
import { Showcase } from "../../library/LibraryPrimitives";
import { Flow } from "../diagrams";

const CORRECT = [
  { icon: HandTap, label: "Answer", desc: "Child chooses", tone: "blue" },
  { icon: CheckCircle, label: "Checkmark", desc: "Green tick + happy sound", tone: "teal" },
  { icon: Star, label: "Reward", desc: "+XP, progress grows", tone: "yellow" },
  { icon: Confetti, label: "Celebrate", desc: "A small, joyful moment", tone: "orange" },
];

const SUPPORTIVE = [
  { icon: HandTap, label: "Answer", desc: "Child chooses", tone: "blue" },
  { icon: HandHeart, label: "Encourage", desc: "“So close — have another go!”", tone: "orange" },
  { icon: Lightbulb, label: "Offer a hint", desc: "Gentle guidance, on tap", tone: "yellow" },
  { icon: ArrowClockwise, label: "Try again", desc: "No penalty, full support", tone: "teal" },
  { icon: Confetti, label: "Succeed & celebrate", desc: "Effort always pays off", tone: "orange" },
];

export function FeedbackSection() {
  return (
    <SectionShell
      id="feedback"
      eyebrow="Feedback Philosophy"
      eyebrowIcon={ChatCircleDots}
      title="Right feels great, wrong feels safe"
      description="Feedback is the emotional core of learning. Correct answers are celebrated; mistakes are met with warmth, a hint and another go. Bloom never punishes — confidence is the goal."
    >
      <div className="space-y-6">
        <Showcase title="Correct answer" description="Rewarding, but calm — confetti is saved for milestones">
          <Flow steps={CORRECT} />
        </Showcase>
        <Showcase title="Incorrect answer" description="Supportive, never punishing — a loop back to success">
          <Flow steps={SUPPORTIVE} />
        </Showcase>

        <div className="grid gap-4 sm:grid-cols-2">
          <div className="rounded-3xl border-2 border-teal/30 bg-teal/[0.06] p-5">
            <p className="font-display text-lg font-extrabold text-teal-ink">We say</p>
            <p className="mt-1 font-semibold text-foreground">“Brilliant — you've got it!” · “So close, have another go.” · “Let's grow this one together.”</p>
          </div>
          <div className="rounded-3xl border-2 border-destructive/25 bg-destructive/[0.06] p-5">
            <p className="font-display text-lg font-extrabold text-destructive-ink">We never say</p>
            <p className="mt-1 font-semibold text-foreground line-through decoration-2">“Wrong.” · “Failed.” · “Try harder.” · red crosses & harsh buzzers</p>
          </div>
        </div>
      </div>
    </SectionShell>
  );
}

export default FeedbackSection;
